import apiClient from "../apiClient";

export const registerUser = async (userData) => {
  try {
    const response = await apiClient.post("users/newUser", userData);
    // console.log(response);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const completeInformation = async (userData) => {
  try {
    const newData = { ...userData };
    const formData = new FormData();
    const ImgUri = newData.imageFile;

    // 1. Agregar imagen (formato correcto)
    if (ImgUri) {
      formData.append("img", ImgUri);
    }

    delete newData.imageFile;

    for (const key in newData) {
      const value = newData[key];
      if (value !== null && value !== undefined && value !== "") {
        if (key === "phoneNumber") {
          formData.append(key, `+52${value}`);
        } else {
          formData.append(key, value);
        }
      }
    }
    // console.log("Completando perfil", formData);

    const response = await apiClient.put("users/completeInformation", formData);
    // console.log("✅ Respuesta al completar info", response.data);
    return response;
  } catch (error) {
    // console.log("❌ respuesta API", error.request || error.message);
    throw error;
  }
};
export const updateProfile = async ({ userData, _id }) => {
  try {
    // console.log("UserData perfil", userData);

    const newData = { ...userData };
    const formData = new FormData();
    const ImgUri = newData.imageFile;

    // 1. Agregar imagen (formato correcto)
    if (ImgUri) {
      formData.append("img", ImgUri);
    }

    // 2. Address como JSON string
    // const address = {
    //   street: newData.street || "",
    //   city: newData.city || "",
    //   state: newData.state || "",
    //   postalCode: newData.postalCode || "",
    // };
    // console.log(address);

    // formData.append("address", address);

    // 3. Agregar otros campos
    const excludeFields = [
      "street",
      "city",
      "state",
      "postalCode",
      "urlImg",
      "phoneNumber",
      "imageFile",
    ];
    for (const key in newData) {
      if (
        !excludeFields.includes(key) &&
        newData[key] !== undefined &&
        newData[key] !== null
      ) {
        formData.append(key, newData[key]);
      }
    }
    // console.log("FromData", formData);

    // 4. Configuración de Axios
    const response = await apiClient.put(`users/updateUser/${_id}`, formData);

    // console.log("✅ Perfil actualizado:", response.data);
    return response.data;
  } catch (error) {
    // console.log("❌ Error completo:", error.request);
    throw error;
  }
};

export const validateSMS = async (userData) => {
  try {
    const response = await apiClient.put("verify/verify-sms", userData);
    return {
      status: true,
      data: response.data,
    };
  } catch (error) {
    throw error;
  }
};

export const loginAuth = async (userData) => {
  try {
    const response = await apiClient.post("login/auth", userData);
    // console.log(response);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getUserById = async (id) => {
  try {
    const response = await apiClient.get(`/users/getUserById/${id}`);
    // console.log("User by id", response?.data);

    return response?.data?.user;
  } catch (error) {
    // console.log("erro user by id", error);

    throw error;
  }
};

// function getImageMimeType(fileName) {
//   const ext = fileName.split(".").pop().toLowerCase();
//   switch (ext) {
//     case "jpg":
//     case "jpeg":
//       return "image/jpeg";
//     case "png":
//       return "image/png";
//     case "gif":
//       return "image/gif";
//     case "bmp":
//       return "image/bmp";
//     case "webp":
//       return "image/webp";
//     case "svg":
//       return "image/svg+xml";
//     default:
//       return "image/jpeg"; // Valor predeterminado en caso de que no se pueda determinar
//   }
// }
